/* eslint-disable no-unused-expressions */
'use strict';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { USER_PROFILE_VALIDATOR } from './validators';
import { Button } from '@src/components/ui/button/button';
import { PhoneInput } from '@src/components/common/phone-input/phone-input';
import { getLatestMediaUrl } from '@src/utils/getLatestMediaUrl';
import React from 'react';
import BaseClassComponent from '../../shared/base.jsx';
import EnumCoreModule from '../../../../src/public/js/enum-core.js';
import CommonModule from '../../../../src/public/js/common.js';
import TextComponent from '../custom-fields/text-component';
import HyperlinkComponent from '../custom-fields/hyperlink-component';
import CheckboxComponent from '../custom-fields/checkbox-component';
import DropdownComponent from '../custom-fields/dropdown-component';
import DateComponent from '../custom-fields/date-component';
import ImageComponent from '../custom-fields/image-component';
import PdfComponent from '../custom-fields/pdf-component';
import InputContainerComponent from '../custom-fields/input-container-component';
import Moment from 'moment';
import toastr from 'toastr';
import { TextField, Checkbox } from '@mui/material';
import PermissionTooltip from '../../common/permission-tooltip';
import $ from 'jquery';

const DEFAULT_IMG = '/assets/images/default_blank.svg';
class ProfileSettingsComponent extends BaseClassComponent {
    constructor(props) {
        super(props);
        this.sellerLocation = this.getSellerLocation();
        let phoneNumber = this.props.user.PhoneNumber || '';
        if (phoneNumber.startsWith('+1')) {
            phoneNumber = phoneNumber.slice(2);
        }

        let componentState = {
            Email: this.props.user.Email || '',
            PhoneNumber: phoneNumber,
            FirstName: this.props.user.FirstName || '',
            LastName: this.props.user.LastName || '',
            sellerLocation: this.sellerLocation,
            DisplayName: `${this.props.user.FirstName} ${
                this.props.user.LastName ? this.props.user.LastName.charAt(0).toUpperCase() : ''
            }`
        };
        const avatarUrl = getLatestMediaUrl(this.props.user, DEFAULT_IMG);
        this.state = {
            ...componentState,
            MediaUrl: avatarUrl,
            IsMember:
                this.props.user.CustomFields.find(cf =>
                    cf.Code.includes('-MembershipStatus-')
                )?.Values?.[0].toLowerCase() === 'active',
            showMembership:
                this.props.user.CustomFields.find(cf => cf.Code.includes('Showmembership'))?.Values?.[0] === 'true',
            userDetails: {},
            SmsConsent: this.props.user.SmsConsent ? JSON.parse(this.props.user.SmsConsent)?.consent : false,
            errors: {
                PhoneNumber: ''
            },
            savingPhoto: false,
            loadingExistingImage: avatarUrl !== DEFAULT_IMG
        };
        this.CustomFields = this.props.user.CustomFields;
        if (!this.CustomFields) {
            this.CustomFields = [];
        }
        this.uploadProfileImage = this.uploadProfileImage.bind(this);

        this.ximg_crop = null;
        this.CanvasCrop = null;
        this.rot = 0;
        this.ratio = 1;
        this.fileOriginalName = '';
        this.renderUserCustomField = this.renderUserCustomField.bind(this);
        this.onCustomValueChanged = this.onCustomValueChanged.bind(this);
        this.onCustomCheckboxChanged = this.onCustomCheckboxChanged.bind(this);
        this.onCustomFileChanged = this.onCustomFileChanged.bind(this);
        this.onCustomDateChanged = this.onCustomDateChanged.bind(this);
        this.gotoNextTab = this.gotoNextTab.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.showBcaaMembership = this.showBcaaMembership.bind(this);
        this.showPhoneInput = this.showPhoneInput.bind(this);
        this.handlePhoneInputChange = this.handlePhoneInputChange.bind(this);
        this.doUpdateUserInfo = this.doUpdateUserInfo.bind(this);

        this.permissionPageType = props.componentType != 'merchant' ? 'consumer' : 'merchant';
    }

    componentDidMount() {
        this.fetchMerchantBCAAMemberJoinDate();
        const self = this;
        const src = this.state.MediaUrl;

        // Set up modal dimensions
        $('#myModal')
            .find('.thumbBox')
            .css('width', 248);
        $('#myModal')
            .find('.thumbBox')
            .css('height', 248);
        $('#myModal')
            .find('.imageBox')
            .css('width', 250);
        $('#myModal')
            .find('.imageBox')
            .css('height', 250);

        // Load existing profile image into the crop tool via proxy (avoids CORS)
        if (src !== DEFAULT_IMG) {
            fetch(`/users/profile/media-proxy?url=${encodeURIComponent(src)}`)
                .then(response => {
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    return response.blob();
                })
                .then(blob => {
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        self.CanvasCrop = $.CanvasCrop({
                            cropBox: '.imageBox',
                            thumbBox: '.thumbBox',
                            imgSrc: e.target.result,
                            limitOver: 2
                        });
                        self.fileOriginalName = 'profile-photo.jpg';
                        $('.crop-controls').removeClass('tw-hidden').addClass('tw-flex');
                        $('.crop-save-btn').removeClass('tw-hidden').addClass('tw-flex');
                        $('.upload-wapper').removeClass('!tw-bg-primary-500').addClass('!tw-bg-gray-500');
                        self.setState({ loadingExistingImage: false });
                    };
                    reader.readAsDataURL(blob);
                })
                .catch(err => {
                    console.error('[ProfileImage] Could not load existing image:', err.message);
                    self.setState({ loadingExistingImage: false });
                });
        } else {
            self.setState({ loadingExistingImage: false });
        }

        $('#upload-file').on('change', function() {
            $('.crop-save-btn').removeClass('tw-hidden').addClass('tw-flex');
            $('.crop-controls').removeClass('tw-hidden').addClass('tw-flex');
            $('.upload-wapper').removeClass('!tw-bg-primary-500').addClass('!tw-bg-gray-500');
            self.fileOriginalName = this.files[0].name;
            var reader = new FileReader();
            reader.onload = function(e) {
                self.CanvasCrop = $.CanvasCrop({
                    cropBox: '.imageBox',
                    thumbBox: '.thumbBox',
                    imgSrc: e.target.result,
                    limitOver: 2
                });
                self.rot = 0;
                self.ratio = 1;
            };
            reader.readAsDataURL(this.files[0]);
        });

        $('#rotateLeft').on('click', function() {
            self.rot -= 90;
            self.rot = self.rot < 0 ? 270 : self.rot;
            self.CanvasCrop.rotate(self.rot);
        });

        $('#rotateRight').on('click', function() {
            self.rot += 90;
            self.rot = self.rot > 360 ? 90 : self.rot;
            self.CanvasCrop.rotate(self.rot);
        });

        $('#my-range').on('change', function() {
            self.CanvasCrop.scale($(this).val());
        });

        $('#my-range').on('input', function() {
            self.CanvasCrop.scale($(this).val());
        });

        $('#zoomOut').on('click', function() {
            var slider = $('#my-range');
            var val = parseFloat(slider.val()) - 0.2;
            val = Math.max(val, parseFloat(slider.attr('min')));
            slider.val(val).trigger('change');
        });

        $('#zoomIn').on('click', function() {
            var slider = $('#my-range');
            var val = parseFloat(slider.val()) + 0.2;
            val = Math.min(val, parseFloat(slider.attr('max')));
            slider.val(val).trigger('change');
        });

        if (this.props.componentType != 'merchant') {
            $('.descripton-textbox').removeClass('required');
            $('.seller-location-textbox').removeClass('required');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof document === 'undefined' || typeof window === 'undefined') {
            return;
        }

        const fname = document.querySelector("input[name='first_name']");
        const lname = document.querySelector("input[name='last_name']");
        if (this.props.user.FirstName !== fname.value || this.props.user.LastName !== lname.value) {
            const displayName = `${fname.value} ${lname.value.charAt(0).toUpperCase() || ''}`;

            if (this.state.DisplayName !== displayName) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ DisplayName: displayName });
            }
        }
    }

    async fetchMerchantBCAAMemberJoinDate() {
        const url = '/membership/bcaa-user-info';
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                userId: this.props.user.ID
            })
        })
            .then(async response => {
                return response.json().then(data => {
                    this.setState({ userDetails: data, showMembership: data.ShowMembership });
                    if (data.length === 0) return null;
                    const customFields = data[0]?.CustomFields;
                    if (!customFields) return null;
                    if (customFields.length === 0) return null;

                    let govID = '';
                    const bcaaMemberStatus = customFields.find(field => field.Code.includes('-BCAAMemberJoinDate-'));
                    const bcaaGovID = customFields.find(field => field.Code.includes('-GovernmentID-'));

                    if (bcaaGovID === null || bcaaGovID?.Values?.length === 0) {
                        govID = 'None';
                    } else {
                        govID = bcaaGovID?.Values[0];
                    }

                    if (bcaaMemberStatus?.Values?.length === 0) return null;
                    return {
                        bcaaJoinDate: bcaaMemberStatus?.Values[0],
                        memberGovIDVerification: govID
                    };
                });
            })
            .catch(error => {
                console.error('error: ', error);
                return null;
            });
    }

    xcropImagePopup(x, xtrgt, w, h) {
        let self = this;
        w = w / 2;
        h = h / 2;
        self.ximg_crop = xtrgt;
        $('#myModal').modal('show');
        $('#myModal')
            .find('.imageBox')
            .css('width', w);
        $('#myModal')
            .find('.imageBox')
            .css('height', h);
    }

    uploadProfileImage(data) {
        if (data.Base64Data.indexOf('blank.png') > 0) {
            $.get('/assets/images/blank.png', function(data) {
                var s = new XMLSerializer().serializeToString(data.documentElement);
                this.setState({
                    MediaUrl: s,
                    MediaOriginalFileName: data.OriginalName
                });
            });
        } else {
            const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.jfif'];
            const OrgName = data.OriginalName;
            let fileExt = OrgName.split('.')
                .pop()
                .toLowerCase(); // Get the file extension

            if (!allowedExtensions.includes('.' + fileExt)) {
                toastr.error('Invalid File Type: Only JPG, PNG or GIF files are supported.');
                return;
            } else {
                this.setState({
                    MediaUrl: data.Base64Data,
                    MediaOriginalFileName: data.OriginalName
                });
            }
        }

        setTimeout(() => {
            const { customFieldDefinition } = this.props;

            const self = this;

            let newUserInfo = {
                ...self.state,
                Email: self.props.user.Email || '',
                PhoneNumber: self.props.user.PhoneNumber || '',
                FirstName: self.props.user.FirstName || '',
                LastName: self.props.user.LastName || '',
                MediaUrl: data.Base64Data,
                MediaOriginalFileName: data.OriginalName
            };

            if (self.props.componentType == 'merchant') {
                let code = '';
                const userLocationObject = customFieldDefinition.find(d => d.Name == 'user_seller_location');

                if (typeof userLocationObject != 'undefined') {
                    code = userLocationObject.Code;
                } else if (typeof self.props.user.CustomFields != 'undefined' && self.props.user.CustomFields != null) {
                    code = self.props.user.CustomFields[0].Code;
                }

                newUserInfo.CustomFields = [];
                newUserInfo.CustomFields.push({
                    Code: code,
                    Values: [self.state.sellerLocation],
                    DataFieldType: 'string'
                });
            }

            if (customFieldDefinition && customFieldDefinition.length > 0) {
                //fe_lastname
                const feLastNameDefinition = customFieldDefinition.find(d => d.Code.includes('-fe_lastname-'));
                if (feLastNameDefinition) {
                    const feLastName = {
                        Code: feLastNameDefinition.Code,
                        DataFieldType: feLastNameDefinition.DataFieldType,
                        IsComparable: feLastNameDefinition.IsComparable,
                        Name: feLastNameDefinition.Name,
                        Values: [this.maskText(this.state.LastName || this.props.user.LastName)]
                    };
                    this.CustomFields = this.CustomFields.filter(f => f.Code !== feLastName.Code);
                    this.CustomFields = [...this.CustomFields, feLastName];
                }
            }

            this.CustomFields.forEach(customField => {
                if (customField.DataInputType === 'datetime') {
                    delete customField.DateValue;
                    delete customField.TimeValue;
                }
            });

            if (newUserInfo.CustomFields) {
                if (this.CustomFields && this.CustomFields.length > 0) {
                    const myArrayFiltered = this.CustomFields.filter(el => {
                        return newUserInfo.CustomFields.some(f => {
                            return f.Code !== el.Code;
                        });
                    });
                    newUserInfo.CustomFields = [...myArrayFiltered, ...newUserInfo.CustomFields];
                }
            } else {
                newUserInfo.CustomFields = this.CustomFields;
            }

            // Exclude avatar custom field — it's already written by the upload route
            // and including stale page-load data here would overwrite it
            if (newUserInfo.CustomFields) {
                newUserInfo.CustomFields = newUserInfo.CustomFields.filter(
                    cf => !cf.Code?.includes('-PrivateAvatarUrl-') && !cf.Code?.includes('-ProfileAvatarUrl-')
                );
            }

            newUserInfo.ProfileProgress = {
                ...(this.props.user.ProfileProgress || {}),
                buyer: { ...(this.props.user.ProfileProgress?.buyer || {}) }
            };

            self.props.updateUserInfo(newUserInfo).then(response => {
                self.showMessage(response);
                self.setState({ savingPhoto: false });
                $('#myModal').modal('hide');
                if (!response) {
                    toastr.success('Profile picture updated successfully.');
                }
                return false;
            }).catch(err => {
                console.error('[uploadProfileImage] Save failed:', err);
                self.setState({ savingPhoto: false });
                $('#myModal').modal('hide');
                toastr.error('Failed to save profile picture. Please try again.');
            });
        }, 0);
    }

    validateProfileFields() {
        $('.error-con').removeClass('error-con');
        $('.required.error-con').removeClass('error-con');
        $('.required').each(function(index, element) {
            var $this = $(element);
            $this.removeClass('error-con');
            let isAddressField =
                $this.data() &&
                $this.data().reactStateComponentName &&
                $this.data().reactStateComponentName == 'Address';
            if (
                $this.val() == '' &&
                $this.val().length < 1 &&
                typeof isAddressField == 'undefined' &&
                $this.find('.custom-image').length === 0
            ) {
                $this.addClass('error-con');
            }

            if ($this.find('.custom-image').length > 0) {
                //PDF validation
                if ($this.find('.isPdf').length > 0 && $this.find('.isPdf').val() === '') {
                    $this.addClass('error-con');
                }

                //Img validation
                if (
                    $this.find('.isImage').length > 0 &&
                    $this
                        .find('.imgpreview')
                        .attr('src')
                        .indexOf('img-placeholder.png') > 0
                ) {
                    $this.addClass('error-con');
                }
            }
        });

        $('.fancy-checkbox')
            .parent('.required')
            .each(function() {
                if (
                    $(this)
                        .find('[type="checkbox"]')
                        .is(':checked') == true
                ) {
                    $(this).removeClass('error-con');
                }
            });
    }

    gotoNextTab(e) {
        var self = this;
        var $tab = $(e.target).parents('.tab-pane');
        var $parent = $tab.attr('id');

        self.validateFields(e, $parent);
    }

    validateFields(e, $parent) {
        var self = this;
        self.validateProfileFields();
        var error = $('#Profile').find('.error-con').length > 0;

        if (!error && CommonModule.validateEmail(this.state.Email) == false) {
            self.showMessage(EnumCoreModule.GetToastStr().Error.INVALID_EMAILS);
            $('.user-email').addClass('error-con');
            e.preventDefault();
            error = true;
            return;
        }

        if (
            !error &&
            $('.media-url-container')
                .attr('src')
                .indexOf('images/blank.png') > 0
        ) {
            self.showMessage(EnumCoreModule.GetToastStr().Error.INVALID_PROFILE_PICTURE);
            $('.media-url-container').addClass('error-con');
            e.preventDefault();
            error = true;
            return;
        }

        if (!error) {
            if ($parent == 'Profile') {
                self.doUpdateUserInfo();
                $('.setting-tab >ul >li:eq(1) a').trigger('click', true);
            }
            if ($parent == 'Address') {
                $('.setting-tab >ul >li:eq(2) a').click();
            }
        }
    }

    onChangeSetStateCallBack() {
        super.onChangeSetStateCallBack();
    }

    maskText(text) {
        if (typeof text !== 'string' || text.length === 0) {
            return '';
        }

        return text[0] + '*'.repeat(text.length - 1);
    }

    doUpdateUserInfo() {
        const { customFieldDefinition } = this.props;

        const objectWithoutKey = (object, key) => {
            const { [key]: deletedKey, ...otherKeys } = object;
            return otherKeys;
        };

        var self = this;
        var newUserInfo = Object.assign({}, self.state);
        newUserInfo = objectWithoutKey(newUserInfo, 'sellerLocation');

        if (this.props.componentType == 'merchant') {
            let code = '';
            var userLocationObject = customFieldDefinition.find(d => d.Name == 'user_seller_location');

            if (typeof userLocationObject != 'undefined') {
                code = userLocationObject.Code;
            } else if (typeof self.props.user.CustomFields != 'undefined' && self.props.user.CustomFields != null) {
                code = self.props.user.CustomFields[0].Code;
            }

            newUserInfo.CustomFields = [];
            newUserInfo.CustomFields.push({
                Code: code,
                Values: [self.state.sellerLocation],
                DataFieldType: 'string'
            });
        }

        if (customFieldDefinition && customFieldDefinition.length > 0) {
            // fe_lastname && show membership
            const feLastNameDefinition = customFieldDefinition.find(d => d.Code.includes('-fe_lastname-'));
            const showMembershipDefinition = customFieldDefinition.find(d => d.Code.includes('Showmembership'));

            updateCustomFieldValue(
                feLastNameDefinition,
                self.maskText(this.state.LastName || this.props.user.LastName)
            );
            updateCustomFieldValue(showMembershipDefinition, self.state.showMembership);

            function updateCustomFieldValue(customField, newValue) {
                if (customField) {
                    const updatedCustomField = {
                        Code: customField.Code,
                        DataFieldType: customField.DataFieldType,
                        IsComparable: customField.IsComparable,
                        Name: customField.Name,
                        Values: [newValue]
                    };
                    self.CustomFields = self.CustomFields.filter(f => f.Code !== updatedCustomField.Code);
                    self.CustomFields = [...self.CustomFields, updatedCustomField];
                }
            }
        }

        this.CustomFields.forEach(customField => {
            if (customField.DataInputType === 'datetime') {
                delete customField.DateValue;
                delete customField.TimeValue;
            }
        });

        if (newUserInfo.CustomFields) {
            if (this.CustomFields && this.CustomFields.length > 0) {
                const myArrayFiltered = this.CustomFields.filter(el => {
                    return newUserInfo.CustomFields.some(f => {
                        return f.Code !== el.Code;
                    });
                });
                newUserInfo.CustomFields = [...myArrayFiltered, ...newUserInfo.CustomFields];
            }
            //newUserInfo.CustomFields = [...newUserInfo.CustomFields, ...this.CustomFields];
        } else {
            newUserInfo.CustomFields = this.CustomFields;
        }

        // Exclude avatar custom field — it's managed by the upload route only
        if (newUserInfo.CustomFields) {
            newUserInfo.CustomFields = newUserInfo.CustomFields.filter(
                cf => !cf.Code?.includes('-PrivateAvatarUrl-') && !cf.Code?.includes('-ProfileAvatarUrl-')
            );
        }

        const profileValidator = this.state.SmsConsent
            ? USER_PROFILE_VALIDATOR
            : USER_PROFILE_VALIDATOR.omit({ PhoneNumber: !this.state.SmsConsent && this.state.PhoneNumber === '' }); //omit only when empty

        const result = profileValidator.safeParse(newUserInfo);
        if (result.success) {
            if (newUserInfo.PhoneNumber) {
                const phoneNumberWithCountyCode = `+1${newUserInfo.PhoneNumber.replace(/ /g, '')}`;
                newUserInfo.PhoneNumber = phoneNumberWithCountyCode;
            }
            self.props.updateUserInfo(newUserInfo).then(error => {
                self.showMessage(error);
                return false;
            });

            this.props.setHasUnsavedChanges(false);
            self.props.onTabChange(self.props.currentTab + 1);
        } else {
            const errors = result.error.format();
            Object.entries(errors).forEach(([key, value]) => {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        [key]: value._errors?.[0]
                    }
                }));
                if (value._errors?.length) {
                    toastr.error(
                        value._errors?.[0],
                        value._errors?.[0].toLowerCase().includes('required') ? 'Missing Field:' : 'Invalid Format'
                    );
                }
            });
        }
    }

    getSellerLocation() {
        var self = this;
        var customField = '';
        if (this.props.componentType == 'merchant') {
            if (self.props.user.CustomFields && self.props.user.CustomFields.length > 0) {
                self.props.user.CustomFields.map(function(cf) {
                    if (cf.Name == 'user_seller_location') {
                        customField = cf.Values[0];
                    }
                });
            }
        }
        return customField;
    }

    renderOpenId() {
        if (this.props.userLogins != null) {
            const firstOpenId = this.props.userLogins[0];
            if (firstOpenId.LoginProvider.startsWith('Facebook')) {
                return (
                    <span>
                        {' '}
                        <i className='fa fa-facebook-square' />{' '}
                    </span>
                );
            } else if (firstOpenId.LoginProvider.startsWith('Google')) {
                return (
                    <span>
                        {' '}
                        <i className='fa fa-google-square' />{' '}
                    </span>
                );
            } else if (firstOpenId.LoginProvider.startsWith('Arcadier')) {
                return (
                    <span>
                        {' '}
                        <i className='fa fa-arcadier-square' />{' '}
                    </span>
                );
            }
        }
        return '';
    }

    isNumber(e) {
        if (!e.clipboardData) {
            var charCode = e.which ? e.which : e.keyCode;
            if (charCode < 48 || charCode > 57) {
                e.preventDefault();
            }

            return;
        }

        e.target.value = e.clipboardData
            .getData('text')
            .replace(/[^\x20-\xFF]/gi, '')
            .replace(/[^0-9]/g, '');
        e.preventDefault();
    }

    isMerchant() {
        if (this.props.user.Roles) {
            const temp = this.props.user.Roles.filter(
                x => x.toLowerCase() === 'merchant' || x.toLowerCase() === 'submerchant'
            );
            if (temp.length > 0) return true;
        }
        return false;
    }

    createCustomFieldComponent(dataInputType, customFieldDefinition, customFieldValues) {
        const commonProps = {
            customFieldDefinition: customFieldDefinition,
            customFieldValues: customFieldValues
        };

        const permissionProps = {
            pagePermissions: this.props.pagePermissions,
            permissionPageType: this.permissionPageType,
            validatePermissionToPerformAction: this.props.validatePermissionToPerformAction
        };

        switch (dataInputType) {
            case 'textfield':
                return <TextComponent {...commonProps} onCustomValueChanged={this.onCustomValueChanged} />;
            case 'dropdown':
                return <DropdownComponent {...commonProps} onCustomValueChanged={this.onCustomValueChanged} />;
            case 'checkbox':
                return <CheckboxComponent {...commonProps} onCustomCheckboxChanged={this.onCustomCheckboxChanged} />;
            case 'upload':
                return (
                    <PdfComponent
                        {...commonProps}
                        {...permissionProps}
                        onCustomFileChanged={this.onCustomFileChanged}
                    />
                );
            case 'datetime':
                return <DateComponent {...commonProps} onCustomDateChanged={this.onCustomDateChanged} />;
            case 'image':
                return (
                    <ImageComponent
                        {...commonProps}
                        {...permissionProps}
                        onCustomFileChanged={this.onCustomFileChanged}
                    />
                );
            case 'hyperlink / URL':
                return <HyperlinkComponent {...commonProps} onCustomValueChanged={this.onCustomValueChanged} />;
            default:
                return null;
        }
    }

    generateTempId() {
        var str = Math.random().toString();
        var n = str.lastIndexOf('.');
        str = str.substring(n + 1, str.length - n);
        return str;
    }

    onCustomDateChanged(customFieldDef, value, isDate) {
        if (customFieldDef && value) {
            if (this.CustomFields) {
                let customField =
                    this.CustomFields && this.CustomFields.length > 0
                        ? this.CustomFields.find(f => f.Code === customFieldDef.Code)
                        : null;
                if (customField) {
                    if (customField.Values && customField.Values.length > 0) {
                        customField.DateValue = Moment.unix(customField.Values[0])
                            .utc()
                            .local()
                            .format('DD/MM/YYYY');
                        customField.TimeValue = Moment.unix(customField.Values[0])
                            .utc()
                            .local()
                            .format('hh:mm A');
                    }
                    if (isDate) {
                        customField.DateValue = value;
                    } else {
                        customField.TimeValue = value;
                    }
                    if (customField.DateValue && customField.TimeValue) {
                        customField.Values = [];
                        var strDate = `${customField.DateValue} ${customField.TimeValue}`;
                        var newDate = Moment(strDate, 'DD/MM/YYYY hh:mm A', true).unix();
                        customField.Values.push(newDate);
                    }
                } else {
                    customField = {
                        Code: customFieldDef.Code,
                        DataInputType: customFieldDef.DataInputType,
                        DataFieldType: customFieldDef.DataFieldType,
                        IsComparable: customFieldDef.IsComparable,
                        Name: customFieldDef.Name,
                        Values: []
                    };
                    if (isDate) {
                        customField.DateValue = value;
                    } else {
                        customField.TimeValue = value;
                    }
                    if (customField.DateValue && customField.TimeValue) {
                        customField.Values = [];
                        var strDate = `${customField.DateValue} ${customField.TimeValue}`;
                        var newDate = Moment(strDate, 'DD/MM/YYYY hh:mm A', true).unix();
                        customField.Values.push(newDate);
                    }
                    this.CustomFields.push(customField);
                }
            }
        }
    }

    onCustomFileChanged(customFieldDefinition, value, fileName) {
        if (customFieldDefinition && value) {
            let customField =
                this.CustomFields && this.CustomFields.length > 0
                    ? this.CustomFields.find(f => f.Code === customFieldDefinition.Code)
                    : null;
            if (customField) {
                customField.Filename = fileName;
                customField.File = value;
                customField.DataInputType = customFieldDefinition.DataInputType;
            } else {
                customField = {
                    Code: customFieldDefinition.Code,
                    DataInputType: customFieldDefinition.DataInputType,
                    DataFieldType: customFieldDefinition.DataFieldType,
                    IsComparable: customFieldDefinition.IsComparable,
                    Name: customFieldDefinition.Name,
                    Values: [],
                    File: value,
                    Filename: fileName
                };
                this.CustomFields.push(customField);
            }
        }
    }

    onCustomCheckboxChanged(customFieldDefinition, name, isCheck) {
        if (customFieldDefinition.Code && name) {
            let customField =
                this.CustomFields && this.CustomFields.length > 0
                    ? this.CustomFields.find(f => f.Code === customFieldDefinition.Code)
                    : null;
            if (customField) {
                if (isCheck) {
                    customField.Values.push(name);
                } else {
                    customField.Values = customField.Values.filter(r => r != name);
                }
            } else {
                if (isCheck) {
                    customField = {
                        Code: customFieldDefinition.Code,
                        DataFieldType: customFieldDefinition.DataFieldType,
                        IsComparable: customFieldDefinition.IsComparable,
                        Name: customFieldDefinition.Name,
                        Values: [name]
                    };
                    this.CustomFields.push(customField);
                }
            }
        }
    }

    onCustomValueChanged(customFieldDefinition, value) {
        if (customFieldDefinition && value) {
            let customField =
                this.CustomFields && this.CustomFields.length > 0
                    ? this.CustomFields.find(f => f.Code === customFieldDefinition.Code)
                    : null;
            if (customField) {
                customField.Values = [];
                customField.Values.push(value);
            } else {
                customField = {
                    Code: customFieldDefinition.Code,
                    DataFieldType: customFieldDefinition.DataFieldType,
                    IsComparable: customFieldDefinition.IsComparable,
                    Name: customFieldDefinition.Name,
                    Values: []
                };
                customField.Values.push(value);
                this.CustomFields.push(customField);
            }
        }
    }

    showProfileImagePopup(e) {
        const self = this;
        const target = e.target;

        this.props.validatePermissionToPerformAction(`edit-${this.permissionPageType}-profile-api`, () => {
            var img = $(target).find('img');
            self.xcropImagePopup(null, img, 500, 500);
        });
    }

    getMerchantBCAAMemberStatus() {
        const { CustomFields } = this.props.user;

        const customField = CustomFields?.find(d => d.Code.includes('-BCAAMemberJoinDate-'));
        if (customField?.length === 0) return '';

        if (customField?.Values?.length === 0) return '';

        return customField?.Values[0];
    }

    cropProfileImage() {
        const self = this;

        this.props.validatePermissionToPerformAction(`edit-${this.permissionPageType}-profile-api`, () => {
            if (!self.CanvasCrop) {
                toastr.error('Please select a photo to upload first.');
                return;
            }

            let src;
            try {
                src = self.CanvasCrop.getDataURL('jpeg');
            } catch (e) {
                toastr.error('Unable to process the image. Please try selecting a new photo.');
                return;
            }

            var tv = jQuery('#upload-file').val();
            if (jQuery.trim(tv) != '') {
                if (self.ximg_crop.is('img')) {
                    self.ximg_crop.attr('src', src);
                } else {
                    self.ximg_crop.css('background-image', src);
                }
            }

            self.setState({ savingPhoto: true });
            self.uploadProfileImage({ Base64Data: src, OriginalName: self.fileOriginalName });
        });
    }

    showBcaaMembership() {
        this.props.setHasUnsavedChanges(true);
        this.setState(
            prevState => ({
                showMembership: !prevState.showMembership
            }),
            async () => {
                let url = '/merchants/settings/showMembership';
                const bodyContent = { showMember: this.state.showMembership };

                try {
                    let response = await fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(bodyContent),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
        );
    }

    showPhoneInput() {
        this.props.setHasUnsavedChanges(true);
        this.setState(prevState => ({
            SmsConsent: !prevState.SmsConsent
        }));
    }

    handlePhoneInputChange(value) {
        this.props.setHasUnsavedChanges(true);
        this.setState(prevState => ({
            PhoneNumber: value,
            errors: {
                ...prevState.errors,
                PhoneNumber: ''
            }
        }));
    }

    renderUserCustomField() {
        const { customFieldDefinition } = this.props;
        const { CustomFields } = this.props.user;
        if (customFieldDefinition && customFieldDefinition.length > 0) {
            let groupNames = [];
            if (this.isMerchant()) {
                groupNames = ['ConsumerMerchant', 'Merchant'];
            } else {
                groupNames = ['ConsumerMerchant', 'Consumer'];
            }

            // console.log('userCustomFieldDefinitions', userCustomFieldDefinitions);
            const userCf = customFieldDefinition.filter(f => groupNames.includes(f.GroupName));
            const userCustomFieldDefinitions = userCf.filter(item => !item.Code.includes('-fe_lastname-'));
            let containerList = [];
            let keyCtr = 0;
            let isReadOnly = false;
            for (let customFieldCtr = 0; customFieldCtr < userCustomFieldDefinitions.length; customFieldCtr++) {
                let currentCustomFieldDef = userCustomFieldDefinitions[customFieldCtr];
                let currentCustomFieldValue = null;
                if (CustomFields) {
                    currentCustomFieldValue = CustomFields.find(f => f.Code === currentCustomFieldDef.Code);
                }
                if (currentCustomFieldDef.Code.includes('-MembershipStatus-')) {
                    continue;
                }
                if (currentCustomFieldDef.Code.includes('-OnboadingComplete-')) {
                    continue;
                }

                if (currentCustomFieldDef.Code.includes('-Showmembership-')) {
                    continue;
                }

                let nextCustomFieldDef = null;
                let nextCustomFieldValue = null;
                if (customFieldCtr + 1 < userCustomFieldDefinitions.length) {
                    nextCustomFieldDef = userCustomFieldDefinitions[customFieldCtr + 1];
                    if (CustomFields) {
                        nextCustomFieldValue = CustomFields.find(f => f.Code === nextCustomFieldDef.Code);
                    }
                }

                if (!nextCustomFieldDef) {
                    containerList.push(
                        <InputContainerComponent
                            key={`InputContainer${++keyCtr}`}
                            components={[
                                this.createCustomFieldComponent(
                                    currentCustomFieldDef.DataInputType,
                                    currentCustomFieldDef,
                                    currentCustomFieldValue
                                )
                            ]}
                        />
                    );
                    break;
                } else {
                    if (
                        currentCustomFieldDef.DataInputType === 'datetime' ||
                        nextCustomFieldDef.DataInputType === 'datetime'
                    ) {
                        if (currentCustomFieldDef.DataFieldType === 'datetime') {
                            containerList.push(
                                <InputContainerComponent
                                    key={`InputContainer${++keyCtr}`}
                                    components={[
                                        this.createCustomFieldComponent(
                                            currentCustomFieldDef.DataInputType,
                                            currentCustomFieldDef,
                                            currentCustomFieldValue
                                        )
                                    ]}
                                />
                            );
                            continue;
                        } else {
                            if (nextCustomFieldDef.DataFieldType === 'datetime') {
                                containerList.push(
                                    <InputContainerComponent
                                        key={`InputContainer${++keyCtr}`}
                                        components={[
                                            this.createCustomFieldComponent(
                                                currentCustomFieldDef.DataInputType,
                                                currentCustomFieldDef,
                                                currentCustomFieldValue
                                            )
                                        ]}
                                    />
                                );
                                continue;
                            }
                        }
                    } else if (
                        currentCustomFieldDef.DataInputType === 'checkbox' ||
                        nextCustomFieldDef.DataInputType === 'checkbox'
                    ) {
                        if (
                            currentCustomFieldDef.DataInputType === 'checkbox' &&
                            nextCustomFieldDef.DataInputType !== 'checkbox'
                        ) {
                            containerList.push(
                                <InputContainerComponent
                                    key={`InputContainer${++keyCtr}`}
                                    components={[
                                        this.createCustomFieldComponent(
                                            currentCustomFieldDef.DataInputType,
                                            currentCustomFieldDef,
                                            currentCustomFieldValue
                                        )
                                    ]}
                                />
                            );
                            continue;
                        }
                        if (
                            currentCustomFieldDef.DataInputType !== 'checkbox' &&
                            nextCustomFieldDef.DataInputType === 'checkbox'
                        ) {
                            containerList.push(
                                <InputContainerComponent
                                    key={`InputContainer${++keyCtr}`}
                                    components={[
                                        this.createCustomFieldComponent(
                                            currentCustomFieldDef.DataInputType,
                                            currentCustomFieldDef,
                                            currentCustomFieldValue
                                        )
                                    ]}
                                />
                            );
                            continue;
                        }
                        if (
                            currentCustomFieldDef.DataInputType === 'checkbox' &&
                            nextCustomFieldDef.DataInputType === 'checkbox'
                        ) {
                            containerList.push(
                                <InputContainerComponent
                                    key={`InputContainer${++keyCtr}`}
                                    components={[
                                        this.createCustomFieldComponent(
                                            currentCustomFieldDef.DataInputType,
                                            currentCustomFieldDef,
                                            currentCustomFieldValue
                                        )
                                    ]}
                                />
                            );
                            containerList.push(
                                <InputContainerComponent
                                    key={`InputContainer${++keyCtr}`}
                                    components={[
                                        this.createCustomFieldComponent(
                                            nextCustomFieldDef.DataInputType,
                                            nextCustomFieldDef,
                                            nextCustomFieldValue
                                        )
                                    ]}
                                />
                            );
                            customFieldCtr++;
                            continue;
                        }
                    } else {
                        containerList.push(
                            <InputContainerComponent
                                key={`InputContainer${++keyCtr}`}
                                components={[
                                    this.createCustomFieldComponent(
                                        currentCustomFieldDef.DataInputType,
                                        currentCustomFieldDef,
                                        currentCustomFieldValue
                                    ),
                                    this.createCustomFieldComponent(
                                        nextCustomFieldDef.DataInputType,
                                        nextCustomFieldDef,
                                        nextCustomFieldValue
                                    )
                                ]}
                            />
                        );
                        customFieldCtr++;
                        continue;
                    }
                }
            }
            return containerList.map(c => c);
        }
        return null;
    }

    abbreviateName(firstname, LastName) {
        if (!firstname && !LastName) {
            return '';
        } else {
            const formattedLastNameInitial = LastName ? LastName.charAt(0).toUpperCase() : '';
            return `${firstname} ${formattedLastNameInitial}`;
        }
    }

    render() {
        var self = this;

        return (
            <React.Fragment>
                <div id='myModal' className='modal-image-cropsec modal fade' role='dialog'>
                    <div className='modal-dialog tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-m-0 tw-mx-auto'>
                        <div className='modal-content tw-relative'>
                            <button type='button' className='close tw-absolute tw-right-3 tw-top-3 tw-z-30 tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-3xl tw-text-gray-500 hover:tw-text-gray-800 tw-leading-none' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                            {(this.state.savingPhoto || this.state.loadingExistingImage) && (
                                <div className='tw-absolute tw-inset-0 tw-bg-white/90 tw-flex tw-items-center tw-justify-center tw-z-20'>
                                    <div className='tw-text-center'>
                                        <i className='fa fa-spinner fa-spin tw-text-primary-500 tw-text-3xl'></i>
                                        <p className='tw-text-sm tw-mt-3 tw-text-gray-600'>
                                            {this.state.savingPhoto ? 'Uploading photo...' : 'Loading your photo...'}
                                        </p>
                                    </div>
                                </div>
                            )}
                            <div className='imageBox'>
                                <div className='thumbBox'></div>
                            </div>
                            <div className='crop-controls tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-hidden'>
                                <button
                                    className='tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-gray-500 tw-p-1'
                                    title='Zoom out'
                                    type='button'
                                    id='zoomOut'
                                >
                                    <i className='fa fa-search-minus'></i>
                                </button>
                                <input
                                    className='cr-slider'
                                    id='my-range'
                                    type='range'
                                    step='0.001'
                                    aria-label='zoom'
                                    min='0.5'
                                    max='3.5000'
                                    defaultValue='1'
                                    style={{ flex: 1 }}
                                />
                                <button
                                    className='tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-gray-500 tw-p-1'
                                    title='Zoom in'
                                    type='button'
                                    id='zoomIn'
                                >
                                    <i className='fa fa-search-plus'></i>
                                </button>
                                <button
                                    className='btn btn-outline-secondary tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded'
                                    title='Rotate left'
                                    id='rotateLeft'
                                    type='button'
                                >
                                    <i className='fa fa-undo'></i>
                                </button>
                                <button
                                    className='btn btn-outline-secondary tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded'
                                    title='Rotate right'
                                    id='rotateRight'
                                    type='button'
                                    style={{ transform: 'scaleX(-1)' }}
                                >
                                    <i className='fa fa-undo'></i>
                                </button>
                            </div>
                            <div className='tw-flex tw-w-full'>
                                <div className='upload-wapper tw-flex-1 !tw-bg-primary-500 tw-relative'>
                                    Select Photo
                                    <input type='file' id='upload-file' accept='image/png, image/jpeg, image/gif' />
                                </div>
                                <div
                                    className='crop-save-btn tw-flex-1 !tw-bg-primary-500 tw-text-white tw-hidden tw-items-center tw-justify-center tw-cursor-pointer tw-font-bold tw-py-5'
                                    id='crop'
                                    aria-label='Save'
                                    onClick={e => this.cropProfileImage()}
                                >
                                    Save Photo
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='tw-my-[32px] tw-gap-[32px] tw-space-y-10 lg:tw-max-w-[650px]'>
                    <div className='tw-space-y-4'>
                        <p className='tw-col-span-2 tw-text-primary-500 tw-font-bold tw-text-[20px] tw-mb-[16px]'>
                            Profile Picture
                        </p>
                        <div>
                            Your profile picture will be visible to Taskers once you message them to inquire about a
                            listing. The picture should be in JPG, PNG, or HEIC format and no larger than 5MB.
                        </div>
                        <div className='tw-w-[180px]'>
                            <div
                                className='tw-aspect-square tw-flex tw-flex-col tw-border tw-border-primary-500 tw-overflow-hidden tw-rounded'
                                onClick={e => this.showProfileImagePopup(e)}
                            >
                                <img src={this.state.MediaUrl} className='tw-w-[180px] tw-h-[180px] tw-object-cover' alt='preview' />
                            </div>
                            <Button
                                variant='contained'
                                className='tw-w-full tw-font-[700]'
                                onClick={e => this.showProfileImagePopup(e)}
                            >
                                UPLOAD PICTURE
                            </Button>
                        </div>
                    </div>

                    <div className='tw-space-y-[16px]'>
                        <div className='tw-grid tw-grid-cols-2 tw-gap-[24px]'>
                            <p className='tw-col-span-2 tw-text-primary-500 tw-font-bold tw-text-[20px]'>
                                Profile Details
                            </p>
                            <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-col-span-2 tw-gap-[24px]'>
                                <TextField
                                    name='display_name'
                                    label='Display Name'
                                    value={this.abbreviateName(
                                        this.state.FirstName || this.props.user.FirstName,
                                        this.state.LastName || this.props.user.LastName
                                    )}
                                    variant='outlined'
                                    className='tw-col-span-2 sm:tw-col-span-1'
                                    InputProps={{
                                        className: 'tw-text-[16px]',
                                        classes: {
                                            input: 'disabled:tw-bg-[#0050C40A]'
                                        },
                                        inputProps: { 'data-react-state-name': 'DisplayName' }
                                    }}
                                    SelectProps={{ className: 'tw-text-[16px]' }}
                                    InputLabelProps={{ className: 'tw-text-[16px]' }}
                                    disabled
                                />
                            </div>
                            <TextField
                                name='first_name'
                                label='First Name'
                                onChange={e => {
                                    this.props.setHasUnsavedChanges(true);
                                    self.onChange(e);
                                }}
                                defaultValue={this.props.user.FirstName}
                                variant='outlined'
                                className='tw-col-span-2 lg:tw-col-span-1 '
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    classes: {
                                        input: 'disabled:tw-bg-[#0050C40A]'
                                    },
                                    inputProps: { 'data-react-state-name': 'FirstName' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                            />
                            <TextField
                                name='last_name'
                                label='Last Name'
                                onChange={e => {
                                    this.props.setHasUnsavedChanges(true);
                                    self.onChange(e);
                                }}
                                defaultValue={this.props.user.LastName}
                                variant='outlined'
                                className='tw-col-span-2 lg:tw-col-span-1'
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    classes: {
                                        input: 'disabled:tw-bg-[#0050C40A]'
                                    },
                                    inputProps: { 'data-react-state-name': 'LastName' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                            />
                            <TextField
                                name='email'
                                label='Email'
                                defaultValue={this.props.user.Email}
                                variant='outlined'
                                className='tw-col-span-2 sm:tw-col-span-1'
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    classes: {
                                        input: 'disabled:tw-bg-[#0050C40A]'
                                    },
                                    inputProps: { 'data-react-state-name': 'DisplayName' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                                disabled
                            />
                            {/* <TextField
                                name='phoneNumber'
                                label='Phone Number'
                                onChange={e => self.onChange(e)}
                                defaultValue={this.props.user.PhoneNumber}
                                onKeyUp={e => this.isNumber(e)}
                                onPaste={e => this.isNumber(e)}
                                variant='outlined'
                                className='tw-col-span-2 lg:tw-col-span-1'
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    inputProps: { 'data-react-state-name': 'PhoneNumber' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                            /> */}
                        </div>
                        <Button
                            variant='contained'
                            href={process.env.CIAM_CHANGE_PASSWORD_REDIRECT}
                            target='_blank'
                            endIcon={<OpenInNewIcon />}
                        >
                            CHANGE EMAIL OR PASSWORD
                        </Button>
                    </div>

                    <div className=''>
                        <div className='tw-grid tw-grid-cols-2 tw-gap-[24px]'>
                            <p className='tw-col-span-2 tw-text-primary-500 tw-font-bold tw-text-[20px]'>
                                BCAA Membership
                            </p>
                            <span className='tw-col-span-2'>
                                To change your BCAA membership information, please contact us at{' '}
                                {<span className='tw-text-primary-500'>1.833.531.7400</span>} or{' '}
                                {<span className='tw-text-primary-500'>support@marketplace.bcaa.com</span>}.
                            </span>
                            <TextField
                                name='membership_id'
                                label='BCAA Membership ID'
                                onChange={e => {
                                    this.props.setHasUnsavedChanges(true);
                                    self.onChange(e);
                                }}
                                defaultValue={this.props.user.BCAAMemberId}
                                variant='outlined'
                                className='tw-col-span-2 lg:tw-col-span-1'
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    classes: {
                                        input: 'disabled:tw-bg-[#0050C40A]'
                                    },
                                    inputProps: { 'data-react-state-name': 'MembershipID' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                                disabled
                            />
                            <TextField
                                name='membership_join_date'
                                label='BCAA Membership Join Date'
                                onChange={e => {
                                    this.props.setHasUnsavedChanges(true);
                                    self.onChange(e);
                                }}
                                defaultValue={this.props.user.BCAAMemberJoinDate}
                                variant='outlined'
                                className='tw-col-span-2 lg:tw-col-span-1'
                                InputProps={{
                                    className: 'tw-text-[16px]',
                                    classes: {
                                        input: 'disabled:tw-bg-[#0050C40A]'
                                    },
                                    inputProps: { 'data-react-state-name': 'MembershipJoinDate' }
                                }}
                                SelectProps={{ className: 'tw-text-[16px]' }}
                                InputLabelProps={{ className: 'tw-text-[16px]' }}
                                disabled
                            />
                        </div>
                    </div>

                    {self.state.IsMember && self.getMerchantBCAAMemberStatus()?.length > 0 && (
                        <label
                            htmlFor='signup-concent'
                            className='tw-cursor-pointer tw-font-normal tw-flex tw-items-center tw-ml-[-10px]'
                        >
                            <Checkbox
                                id='signup-concent'
                                size='large'
                                className='tw-border-2 tw-border-primary-500 tw-text-primary-500 checked:tw-border-primary tw-mt-[-5px]'
                                onChange={this.showBcaaMembership}
                                value={this.state.showMembership}
                                checked={this.state.showMembership}
                            />
                            <span>Display my join date (Year) to other users</span>
                        </label>
                    )}

                    <div className='tw-space-y-[24px]'>
                        <p className='tw-text-primary-500 tw-font-bold tw-text-[20px]'>Marketing Consent</p>

                        <Button
                            variant='contained'
                            className='md:tw-max-w-[330px]'
                            href={process.env.UPDATE_COMMUNICATION_PREFERENCES_LINK}
                        >
                            UPDATE COMMUNICATION PREFERENCES
                        </Button>
                    </div>
                    <div className='tw-space-y-[24px]'>
                        <p className='tw-text-primary-500 tw-font-bold tw-text-[20px]'>
                            Stay in the loop with SMS alerts
                        </p>
                        <p>Get important updates instantly - no need to check your email! </p>

                        <div className='tw-grid tw-grid-cols-2'>
                            <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-col-span-2'>
                                <PhoneInput
                                    name='phoneNumber'
                                    defaultValue={this.props.user.PhoneNumber}
                                    value={this.state.PhoneNumber}
                                    onChange={this.handlePhoneInputChange}
                                    helperText={this.state.errors.PhoneNumber}
                                />
                            </div>
                        </div>

                        <div className='tw-flex tw-gap-[8px] tw-items-start'>
                            <label
                                htmlFor='sms-subscribe'
                                className='tw-cursor-pointer tw-font-normal tw-flex tw-items-center tw-ml-[-10px] tw-mb-0'
                            >
                                <Checkbox
                                    id='sms-subscribe'
                                    size='small'
                                    className='tw-border-2 tw-border-primary-500 tw-text-primary-500 checked:tw-border-primary tw-mt-[-5px]'
                                    onChange={this.showPhoneInput}
                                    value={this.state.SmsConsent}
                                    checked={this.state.SmsConsent}
                                />
                                <span>I agree to receive SMS messages about my account and transactions.*</span>
                            </label>
                        </div>
                        <p className='tw-text-[12px] tw-text-bcaa-grey-700'>*Standard message and data rates apply.</p>
                    </div>
                </div>
                <div className='tw-flex tw-justify-end lg:tw-items-center tw-flex-col lg:tw-flex-row tw-items-stretch tw-gap-2'>
                    <Button variant='contained' onClick={this.doUpdateUserInfo}>
                        NEXT
                    </Button>
                </div>
            </React.Fragment>
        );
    }
}

export default ProfileSettingsComponent;
